const DEFAULT_OPTIONS = {
  // The root to use for intersection.
  // If not provided, use the top-level document's viewport.
  root: null,
  // Same as margin, can be 1, 2, 3 or 4 components, possibly negative lengths.
  // If an explicit root element is specified, components may be percentages of the
  // root element size.  If no explicit root element is specified, using a percentage
  // is an error.
  rootMargin: '0px',
  // Threshold(s) at which to trigger callback, specified as a ratio, or list of
  // ratios, of (visible area / total area) of the observed element (hence all
  // entries must be in the range [0, 1]).  Callback will be invoked when the visible
  // ratio of the observed element crosses a threshold in the list.
  threshold: 0.4
}

class InView {
  constructor (options = {}) {
    this.options = Object.assign({}, DEFAULT_OPTIONS, options)

    // Function binding
    this.onChange = this.onChange.bind(this)

    // Instanciate an IntersectionObserver
    this.observer = new IntersectionObserver(this.onChange, this.options)

    this.run();
  }

  // Observe elements mathcing the `.js-in-view` selector
  run() {
    const els = [...document.querySelectorAll('.js-in-view:not(.in-view)')];
    els.forEach(el => this.observer.observe(el));
  }

  // Disconnect entire IntersectionObserver
  destroy() {
    this.observer.disconnect();
  }

  // Reset running IntersectionObserver
  reset() {
    this.destroy();
    this.run();
  }

  destroy () {
    // Disable entire IntersectionObserver
    this.observer.disconnect()
  }

  observe (els) {
    // Start observing each element in the list
    els.forEach(el => this.observer.observe(el))
  }

  onChange (entries) {
    entries.forEach(entry => {
      if (entry.intersectionRatio > 0 || entry.isIntersecting) {
        // Add in-view class
        entry.target.classList.add('in-view')
        // Stop observing the current target
        this.observer.unobserve(entry.target)
        // Play video
        if (entry.target.tagName === 'VIDEO') {
          //entry.target.play();
        }
      }
    })
  }
}

export default InView
